export default __webpack_public_path__ + "static/media/gcashLogo.467330fc.png";